import Styles from './UploadsDrawer.module.scss'
import { UploadedFile } from '../UploadedFile'
import { useUploadsTab } from '../UploadsTabContext'
import { Carousel } from 'components/Carousel/Carousel'
import { SectionHeader } from './SectionHeader'
import { useUploads } from '../useUploads'
import { collectResults } from 'utils/query'
import { getMediaFiles } from '../getMediaFiles'
import { ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'
import { LoadingCarousel } from './LoadingCarousel'

export const Uploads = () => {
  const { openPanel } = useUploadsTab()
  const uploadsQuery = useUploads()
  const uploads = collectResults(uploadsQuery, (data) => data.files)
  const mediaFiles = getMediaFiles(uploads, ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES)

  if (uploadsQuery.isFetched && !mediaFiles.length) {
    return null
  }

  return (
    <div>
      <SectionHeader
        title="Uploads"
        onPress={() => setTimeout(() => openPanel({ panel: 'uploads', panelProps: {} }), 100)}
      />
      <div className={Styles.sectionContainer}>
        {!uploadsQuery.isFetched && <LoadingCarousel />}
        {uploadsQuery.isFetched && (
          <Carousel slideGap={7}>
            {mediaFiles.slice(0, 6).map((file, index) => (
              <div key={index} className={Styles.mediaFileContainer}>
                <UploadedFile key={file.id} file={file} size={{ height: 100, width: 100 }} />
              </div>
            ))}
          </Carousel>
        )}
      </div>
    </div>
  )
}
